// Environment configuration
const ENV = process.env.REACT_APP_ENV || 'development';

// Firebase project ID
const projectId = 'tee-time-finder-2025-9b689';

// Base URLs for different environments
const API_BASE_URL =
  ENV === 'development'
    ? 'http://localhost:5002/tee-time-finder-2025-9b689/us-central1'
    : `https://us-central1-${projectId}.cloudfunctions.net`;

// Debug API configuration
console.log('API Configuration:');
console.log('Environment:', ENV);
console.log('Project ID:', projectId);
console.log('API Base URL:', API_BASE_URL);

// Web app URL
const WEB_APP_URL = 'https://tee-time-finder-2025-9b689.web.app';

export const API_ENDPOINTS = {
  searchTeeTimes: `${API_BASE_URL}/searchTeeTimes`,
  getCourseInfo: `${API_BASE_URL}/getCourseInfo`,
  createSubscription: `${API_BASE_URL}/createSubscription`,
  checkSubscription: `${API_BASE_URL}/checkSubscription`,
  getStripeConfig: `${API_BASE_URL}/getStripeConfig`
};

// Debug API endpoints
console.log('API Endpoints:', API_ENDPOINTS);

export const WEB_APP_CONFIG = {
  baseUrl: WEB_APP_URL,
  successUrl: `${WEB_APP_URL}/payment-success`,
  cancelUrl: `${WEB_APP_URL}/upgrade`
}; 